import { useMutation } from "react-query";
import { deleteEmployeesByNumber } from "../../../../../actions/Employees";

export const useDeleteEmployee = () => {
  return useMutation(deleteEmployeesByNumber);
};
